import { ProfileKeyword } from '../../types/keywords'
import { PracticeProfile } from '../../types/practice'
import { Location } from '../../types/index'
import { SpecialistProfile } from '../../types/specialist'

export enum AutocompleteSearchTypes {
  practice = 'practice',
  specialist = 'specialist'
}

export enum AlternativeNavigationSearchTypes {
  practices = 'practices',
  specialists = 'specialists',
  dentist = 'dentistry',
  careHome = 'care-homes',
  healthAndSocialCare = 'home-carers',
  hospital = 'hospitals',
  pharmacy = 'pharmacies'
}

export enum SearchTypes {
  practices = 'practices',
  specialists = 'specialists',
  dentist = 'dentistry',
  careHome = 'care-home',
  healthAndSocialCare = 'homecare',
  hospital = 'hospital',
  pharmacy = 'pharmacy'
}

export enum ProfileQueryTypes {
  dentist = SearchTypes.dentist,
  careHome = SearchTypes.careHome,
  healthAndSocialCare = SearchTypes.healthAndSocialCare,
  hospital = SearchTypes.hospital,
  pharmacy = SearchTypes.pharmacy
}

export enum ProfileTypes {
  practices = SearchTypes.practices,
  specialists = SearchTypes.specialists,
  dentist = SearchTypes.dentist,
  careHome = SearchTypes.careHome,
  healthAndSocialCare = SearchTypes.healthAndSocialCare,
  hospital = SearchTypes.hospital,
  pharmacy = SearchTypes.pharmacy
}

export enum SortType {
  relevance = '',
  nearest = 'nearest',
  rating = 'rating',
  recommended = 'recommended'
}

export interface HomePageProviderFilters {
  searchType: SearchTypes
  searchString: string
  selectedKeywordName?: string
  selectedKeywordId?: string
  selectedKeywordSlug?: string
  selectedLocationName?: string
  selectedLocationId?: string
  selectedLocationSlug?: string
}

export interface BuildUrlParams {
  keywordSlug?: string
  procedureConditionSlug?: string | null
  slug?: string | null
  location?: string
  profileType?: SearchTypes
  language?: string
}

export type AutocompleteSpecialty = Pick<ProfileKeyword, 'id' | 'iconUri' | 'name' | 'slug' | 'type'>

export type AutocompleteConditionAndProcedure = Pick<ProfileKeyword, 'id' | 'iconUri' | 'name' | 'slug' | 'type'>

export interface HomePageProviderState {
  state: {
    practicesAutocomplete: Pick<PracticeProfile, 'id' | 'images' | 'name' | 'slug'>[]
    specialistsAutocomplete: Pick<SpecialistProfile, 'id' | 'images' | 'firstName' | 'lastName' | 'slug' | 'keywords'>[]
    specialties: AutocompleteSpecialty[]
    conditionsProcedures: AutocompleteConditionAndProcedure[]
    locations: Location[]
    filters: HomePageProviderFilters
    isKeywordChanged: boolean
    isLocationChanged: boolean
    isKeywordValidationFailed: boolean
    isLocationValidationFailed: boolean
    isLoadingButtonState: boolean
  }
  resetLocationsAutocomplete: () => void
  changeFilter: (key: string, value: string | number | boolean | string[]) => void
  changeLocation: () => void
  changeSearch: (search: string) => void
  changeLocationSearch: (search: string) => void
  changeSearchType: (searchType: SearchTypes) => void
  changeCurrentLocation: (locationId: string, locationName: string, locationSlug?: string) => void
  openProfilePage: (slug: string) => void
  loadCurrentLocationByLatLon: (lat: string, lon: string) => Promise<void>
  buildUrl: () => string | null
  validate: () => void
  resetValidation: () => void
  resetKeywordSearch: () => void
  changeButtonLoadingState: (isLoadingButtonState: boolean) => void
  isSpecialistSearch: boolean
}

export interface HomePageProviderProps {
  conditionsAndProcedures: ProfileKeyword[]
  specialties: ProfileKeyword[]
  locationsAutocomplete: Location[]
  practicesAutocomplete?: Pick<PracticeProfile, 'id' | 'images' | 'name' | 'slug'>[]
  specialistsAutocomplete?: Pick<SpecialistProfile, 'id' | 'images' | 'firstName' | 'lastName' | 'slug' | 'keywords'>[]
  defaultLocation: Location
}
